import React from 'react';
import CloseButton from '../CloseButton';
import type { TopBannerProps } from './TopBanner.types';
import { Text } from '..';
import { dataHooks } from './TopBanner.constants';
import { ActionLink } from './components/ActionLink/ActionLink';
import { ActionButton } from './components/ActionButton/ActionButton';
import { st, classes } from './TopBanner.st.css';
import { ZIndex } from '../common/ZIndex';

const TopBanner = ({
  dismissible = true,
  dismissLabel,
  zIndex,
  position = 'static',
  onDismiss,
  action,
  dataHook,
  className,
  children,
}: TopBannerProps) => (
  <div
    data-hook={dataHook}
    role="status"
    aria-live="polite"
    style={{ zIndex: zIndex ?? ZIndex.topBanner }}
    className={st(classes.root, { dismissible, position }, className)}
  >
    <div className={classes.contentContainer}>
      <Text light size="medium" weight="normal" dataHook={dataHooks.content}>
        {children}
      </Text>
      {action && (
        <div className={classes.action} data-hook={dataHooks.action}>
          {action}
        </div>
      )}
    </div>

    {dismissible && (
      <CloseButton
        dataHook={dataHooks.dismissButton}
        skin="lightFilled"
        size="small"
        aria-label={dismissLabel}
        onClick={onDismiss}
      />
    )}
  </div>
);

TopBanner.displayName = 'TopBanner';

TopBanner.ActionButton = ActionButton;
TopBanner.ActionLink = ActionLink;

export default TopBanner;
